import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';

export default function errorPhoneTips() {
  return tips.error(
    {
      content: h => {
        return (
          <p>
            {i18n_t('该手机号已将腾讯云通知列入免打扰，若需接受短信验证码，')}
            <span
              onClick={() => {
                dispatchRouter(CONSTANT_URL.consultUrl);
              }}
              style="color: #0444d9;text-decoration: underline;cursor: pointer;">
              {i18n_t('请前往')}
            </span>
            {i18n_t('腾讯云官网咨询处理')}
          </p>
        );
      },
      closeBtn: true,
    },
    0,
  );
}
